import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { type FooterV2Response } from '@cx-web/domain-types';

import Logo from '../../primitives/Logo';
import { FooterV2 } from '../footer/FooterV2';
import { type CmpProps } from '../footer/types';

import { getSocialLinks } from './social-links';

export type CxFooterProps = {
  cmpProps?: CmpProps;
  footerData?: FooterV2Response;
  isAdmiralCookieBannerEnabled: boolean;
  logo?: ReactNode;
  resourcesUrl: string;
};

export const CxFooter = ({ cmpProps, footerData, isAdmiralCookieBannerEnabled, logo, resourcesUrl }: CxFooterProps) => {
  const { t } = useTranslation(['label']);

  return (
    <FooterV2
      cmpProps={cmpProps}
      footerData={footerData}
      isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
      legalAge={t('CX_LEGAL_AGE')}
      legalText={t('CX_FOOTER_LEGAL')}
      logo={logo ?? <Logo resourcesUrl={resourcesUrl} />}
      socialLinks={getSocialLinks(t)}
    />
  );
};
